module.exports = __webpack_public_path__ + "static/step1-5aee8913e740d01ad70a6477b0552407.png";